import React, { useEffect, useRef } from 'react';
import { SERVICES, TESTIMONIALS } from '../data/siteData';

function ServiceCard({ svc, index }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { el.classList.add('on'); obs.unobserve(el); } },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <article
      className="sc-card rs"
      ref={ref}
      style={{ transitionDelay: `${index * 0.06}s` }}
      aria-label={`Service: ${svc.title}`}
    >
      <div className="sc-ic" style={{ background: svc.color }}>
        <span>{svc.icon}</span>
      </div>
      <h3 className="sc-title">{svc.title}</h3>
      <p className="sc-desc">{svc.desc}</p>
      <div className="sc-tags">
        {svc.tags.map((t) => (
          <span className="sc-tag" key={t} style={{ color: svc.textColor, background: svc.color, border: `1px solid ${svc.color}` }}>{t}</span>
        ))}
      </div>
    </article>
  );
}

function TestimonialCard({ t }) {
  return (
    <article className="tc rs" aria-label={`Testimonial from ${t.name}`}>
      <div className="tc-stars">{'★'.repeat(t.stars)}</div>
      <div className="tc-quote">"</div>
      <p className="tc-text">{t.text}</p>
      <div className="tc-auth">
        <div className="tc-av" style={{ background: t.avatarBg }}>{t.avatar}</div>
        <div>
          <div className="tc-name">{t.name}</div>
          <div className="tc-role">{t.role}</div>
        </div>
      </div>
    </article>
  );
}

export default function Services() {
  const headerRef = useRef(null);
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { el.classList.add('on'); obs.unobserve(el); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="services-sec" id="services" aria-labelledby="services-heading">
      <div className="wrap">
        <div className="sec-hd rv" ref={headerRef}>
          <div className="chip">⚙️ Our Services</div>
          <h2 id="services-heading">Full-Stack Tech Expertise</h2>
          <p>From AI Agents to Cloud Infrastructure — we design, build, and scale the technology that powers your competitive edge.</p>
        </div>

        {/* Service cards grid */}
        <div className="sc-grid">
          {SERVICES.map((svc, i) => (
            <ServiceCard key={svc.title} svc={svc} index={i} />
          ))}
        </div>

        {/* Testimonials */}
        <div className="sec-hd rv" style={{ marginTop: '5rem' }}>
          <div className="chip">⭐ Client Stories</div>
          <h2>What Our Clients Say</h2>
        </div>
        <div className="testi-grid">
          {TESTIMONIALS.map((t) => (
            <TestimonialCard key={t.name} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
